// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Menu_menu__1\\+Xaz {
  position: fixed;
  width: 280px;
  height: 100vh;
  background: #F9F9FA;
  padding-top: 62px;
}
.Menu_menu__1\\+Xaz > ul {
  width: 232px !important;
  margin: 0 24px;
}
.Menu_menu__1\\+Xaz ul {
  padding: 0;
  width: inherit;
}
.Menu_menu__1\\+Xaz ul li {
  list-style-type: none;
  margin: 0;
  padding: 0;
  border-radius: 4px;
}
.Menu_menu__1\\+Xaz .Menu_section__QwORC {
  margin-top: 28px;
}
.Menu_menu__1\\+Xaz legend {
  font-size: 12px;
  color: #838390;
  font-weight: 300;
}
.Menu_menu__1\\+Xaz .Menu_item__cCszl {
  width: inherit;
  height: 36px;
  line-height: 36px;
  padding: 0;
  margin: 6px 0;
}
.Menu_menu__1\\+Xaz .Menu_item__cCszl .Menu_link__O61mo {
  width: 100%;
}
.Menu_menu__1\\+Xaz .Menu_item__cCszl .Menu_link__O61mo a {
  width: inherit;
  display: block;
  color: #3E3E50;
  font-weight: 500;
}
.Menu_menu__1\\+Xaz .Menu_item__cCszl svg {
  vertical-align: middle;
  margin: 0 12px 0 8px;
}
.Menu_menu__1\\+Xaz .Menu_item__cCszl svg path {
  fill: #3E3E50;
}
.Menu_menu__1\\+Xaz .Menu_item__cCszl:hover {
  background-color: #E0E0E3;
  cursor: pointer;
}
.Menu_menu__1\\+Xaz .Menu_item__cCszl:hover a {
  text-decoration: none;
}
.Menu_menu__1\\+Xaz .Menu_item__cCszl.Menu_logout__WFCef {
  position: fixed;
  bottom: 18px;
}
.Menu_menu__1\\+Xaz .Menu_item__cCszl .Menu_active__l80WC a {
  color: #00007A;
}
.Menu_menu__1\\+Xaz .Menu_item__cCszl .Menu_active__l80WC svg path {
  fill: #00007A;
}`, "",{"version":3,"sources":["webpack://./src/components/reporting/components/Menu/Menu.module.scss","webpack://./src/components/reporting/styles/colors.scss"],"names":[],"mappings":"AAKA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBCFM;EDGN,iBAAA;AAgBF;AAdE;EACE,uBAAA;EACA,cAAA;AAgBJ;AAbE;EACE,UAAA;EACA,cAAA;AAeJ;AAbI;EACE,qBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AAeN;AAXE;EACE,gBAAA;AAaJ;AAVE;EACE,eAAA;EACA,cC/BI;EDgCJ,gBAAA;AAYJ;AATE;EACE,cAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;AAWJ;AATI;EACE,WAAA;AAWN;AATM;EACE,cAAA;EACA,cAAA;EACA,cCjDA;EDkDA,gBAAA;AAWR;AAPI;EACE,sBAAA;EACA,oBAAA;AASN;AAPM;EAAM,aC1DJ;ADoER;AAPI;EACE,yBC3DE;ED4DF,eAAA;AASN;AAPM;EACE,qBAAA;AASR;AALI;EACE,eAAA;EACA,YAAA;AAON;AAHM;EAAG,cCtED;AD4ER;AALM;EAAU,aCvER;AD+ER","sourcesContent":["@use 'components/reporting/styles/colors.scss';\n@use 'styles/sizes.scss';\n\n$sign-out-height: 44px;\n\n.menu {\n  position: fixed;\n  width: 280px;\n  height: 100vh;\n  background: colors.$grey5;\n  padding-top: 62px;\n\n  > ul {\n    width: 232px!important;\n    margin: 0 24px;\n  }\n\n  ul{\n    padding: 0;\n    width: inherit;\n\n    li{\n      list-style-type: none;\n      margin: 0;\n      padding: 0;\n      border-radius: 4px;\n    }\n  }\n\n  .section{\n    margin-top: 28px;\n  }\n\n  legend{\n    font-size: 12px;\n    color: colors.$grey2;\n    font-weight: 300;\n  }\n\n  .item{\n    width: inherit;\n    height: 36px;\n    line-height: 36px;\n    padding: 0;\n    margin: 6px 0;\n\n    .link{\n      width: 100%;\n      \n      a {\n        width: inherit;\n        display: block;\n        color: colors.$grey1;\n        font-weight: 500;\n      }\n    }\n\n    svg{\n      vertical-align: middle;\n      margin: 0 12px 0 8px;\n  \n      path{ fill: colors.$grey1; }\n    }\n\n    &:hover{\n      background-color: colors.$grey4;\n      cursor: pointer;\n\n      a{\n        text-decoration: none;\n      }\n    }\n\n    &.logout{\n      position: fixed;\n      bottom: 18px;\n    }\n\n    .active{\n      a{ color: colors.$blue1; }\n      svg path{ fill: colors.$blue1; }\n    }\n  }\n}","$dark: #121217;\n$light: #FFFFFF;\n\n$grey1: #3E3E50;\n$grey2: #838390;\n$grey3: #C3C3C9;\n$grey4: #E0E0E3;\n$grey5: #F9F9FA;\n\n$blue1: #00007A;\n$blue2: #0000C9;\n$blue3: #4343FF;\n$blue4: #8686FF;\n$blue5: #D8D8FF;\n$blueLogo: #000093;\n\n$orange1: #DA8200;\n$orange2: #FFA92C;\n$orange3: #FFC26B;\n$orange4: #FFE1B7;\n$orange5: #FFF3E3;\n\n$green1: #033E0F;\n$green2: #218214;\n$green3: #58B441;\n$green4: #89D96B;\n$green5: #E1F8CE;\n\n$brick1: #7D1F01;\n$brick2: #B94402;\n$brick3: #E78D3D;\n$brick4: #FBD298;\n$brick5: #FDEBCB;\n\n$red1: #540726;\n$red2: #7C1028;\n$red3: #BD454A;\n$red4: #F4ADA1;\n$red5: #F9D9CF;\n\n\n:export {\n    light: $light;\n    dark: $dark;\n    blue1: $blue1;\n    blue2: $blue2;\n    blue3: $blue3;\n    blue4: $blue4;\n    blue5: $blue5;\n    orange1: $orange1;\n    orange2: $orange2;\n    orange3: $orange3;\n    orange4: $orange4;\n    orange5: $orange5;\n    grey1: $grey1;\n    grey2: $grey2;\n    grey3: $grey3;\n    grey4: $grey4;\n    grey5: $grey5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"light": `#FFFFFF`,
	"dark": `#121217`,
	"blue1": `#00007A`,
	"blue2": `#0000C9`,
	"blue3": `#4343FF`,
	"blue4": `#8686FF`,
	"blue5": `#D8D8FF`,
	"orange1": `#DA8200`,
	"orange2": `#FFA92C`,
	"orange3": `#FFC26B`,
	"orange4": `#FFE1B7`,
	"orange5": `#FFF3E3`,
	"grey1": `#3E3E50`,
	"grey2": `#838390`,
	"grey3": `#C3C3C9`,
	"grey4": `#E0E0E3`,
	"grey5": `#F9F9FA`,
	"menu": `Menu_menu__1+Xaz`,
	"section": `Menu_section__QwORC`,
	"item": `Menu_item__cCszl`,
	"link": `Menu_link__O61mo`,
	"logout": `Menu_logout__WFCef`,
	"active": `Menu_active__l80WC`
};
export default ___CSS_LOADER_EXPORT___;
